import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/leftArrowFilled.svg'
import _imports_1 from '@/assets/rightArrowFilled.svg'


const _hoisted_1 = { class: "responsive-pagination" }
const _hoisted_2 = { class: "text-sm text-gray-700" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_5 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "mx-2 flex" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "flex items-center justify-center w-10 h-8 ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.display==true)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex items-center justify-between bottom-0 px-5 py-3", (_ctx.currentPage * _ctx.pageSize) > (_ctx.dynamicPagination) && (_ctx.entityId==20010||_ctx.entityId==20011) ?'border-t border-lightgrey':'border-none'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_2, [
              _cache[3] || (_cache[3] = _createTextVNode(" Showing ")),
              _createElementVNode("span", _hoisted_3, _toDisplayString((_ctx.currentPage - 1) * _ctx.pageSize + 1), 1),
              _cache[4] || (_cache[4] = _createTextVNode(" - ")),
              (_ctx.dynamicPagination > _ctx.pageSize)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.currentPage * _ctx.pageSize), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.dynamicPagination), 1)),
              _cache[5] || (_cache[5] = _createTextVNode(" of ")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.dynamicPagination), 1),
              _cache[6] || (_cache[6] = _createTextVNode(" results "))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["inline-flex items-center justify-center border border-lightgrey rounded w-8 h-8 cursor-pointer", _ctx.cantGoBack ? 'disabled pointer-events-none' : '']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPreviousPage()))
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "flex items-center justify-center" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "w-3 h-4"
                })
              ], -1)
            ]), 2),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
                class: _normalizeClass([_ctx.currentPage <=9 ? 'dropDownWidthSingleDigit': 'dropDownWidthDobleDigit', "inputboxstyling"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: i
                  }, _toDisplayString(i), 9, _hoisted_9))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.currentPage]
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "pr-2" }, "of", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.totalPages), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["inline-flex items-center justify-center border border-lightgrey rounded w-8 h-8 cursor-pointer", _ctx.cantGoForward ? 'disabled pointer-events-none':'']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToNextPage()))
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "flex items-center justify-center" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "w-3 h-4"
                })
              ], -1)
            ]), 2)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}